import "./GatewaySkeleton.css";

export default function GatewaySkeleton() {

    return (

        <div className="gateway-skeleton">

            <div className="gateway-logo-skeleton"/>

            <div className="gateway-text">

                <div className="line"/>

                <div className="line small"/>

            </div>

        </div>

    );

}